// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN RUST INSTEAD.

// @ts-ignore
import { __SPACETIMEDB__, AlgebraicType, ProductType, BuiltinType, ProductTypeElement, DatabaseTable, AlgebraicValue, ReducerArgsAdapter, SumTypeVariant, Serializer, Identity, Address, ReducerEvent, Reducer, SpacetimeDBClient } from "@clockworklabs/spacetimedb-sdk";

export class UpdateLayoutNameReducer extends Reducer
{
	public static reducerName: string = "UpdateLayoutName";
	public static call(_layoutId: number, _name: string) {
		this.getReducer().call(_layoutId, _name);
	}

	public call(_layoutId: number, _name: string) {
		const serializer = this.client.getSerializer();
		let _layoutIdType = AlgebraicType.createPrimitiveType(BuiltinType.Type.U32);
		serializer.write(_layoutIdType, _layoutId);
		let _nameType = AlgebraicType.createPrimitiveType(BuiltinType.Type.String);
		serializer.write(_nameType, _name);
		this.client.call("UpdateLayoutName", serializer);
	}

	public static deserializeArgs(adapter: ReducerArgsAdapter): any[] {
		let layoutIdType = AlgebraicType.createPrimitiveType(BuiltinType.Type.U32);
		let layoutIdValue = AlgebraicValue.deserialize(layoutIdType, adapter.next())
		let layoutId = layoutIdValue.asNumber();
		let nameType = AlgebraicType.createPrimitiveType(BuiltinType.Type.String);
		let nameValue = AlgebraicValue.deserialize(nameType, adapter.next())
		let name = nameValue.asString();
		return [layoutId, name];
	}

	public static on(callback: (reducerEvent: ReducerEvent, _layoutId: number, _name: string) => void) {
		this.getReducer().on(callback);
	}
	public on(callback: (reducerEvent: ReducerEvent, _layoutId: number, _name: string) => void)
	{
		this.client.on("reducer:UpdateLayoutName", callback);
	}
}


export default UpdateLayoutNameReducer
